// extracted by mini-css-extract-plugin
export default {"title":"modal-container_title__j2ip-"};